<div class="main-container">
    <div class="mdl-container">
        <div class="d-grid mdl-header">
            <div class="center-svg"><img src="assets/svg/p-item-icon.svg" alt=""></div>
            <div><h4 class="text-semibold">Modificar partidas</h4></div>
            <div><h3 class="color-gray text-semibold"><div class="center-svg"><img (click)="closeMdl();" class="close-button" src="assets/svg/close-icon.svg" alt=""></div></h3></div>
        </div>
        <div class="mdl-body">
            <div class="prospectos-table mt-3">
                <table class="stage-history-table">
                    <thead>
                        <tr>
                            <th>
                                <div class="th-content">
                                    <span>Nombre del producto</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Cantidad</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Precio producto</span>
                                </div>
                            </th>
                            <th>
                                <div class="th-content">
                                    <span>Total</span>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        @for(item of items; track item.presupuesto_item_id; let i = $index) {
                            <tr>
                                <td>
                                    <span class="td-readonly">{{item.producto_servicio}}</span>
                                </td>
                                <td>
                                    <input 
                                        type="text" 
                                        class="td-input" 
                                        placeholder="Ingrese la cantidad"
                                        [value]="formatNumber(item.cantidad)"
                                        (input)="updateCantidad(i, $event)"
                                        (blur)="calculateTotal(i)">   
                                </td>
                                <td>
                                    <input 
                                        type="text" 
                                        class="td-input" 
                                        placeholder="Ingrese valor"
                                        [value]="formatNumber(item.precio_unitario)"
                                        (input)="updatePrecio(i, $event)"
                                        (blur)="calculateTotal(i)">
                                </td>
                                <td>
                                    <span class="td-readonly">{{(item.cantidad * item.precio_unitario) | number:'1.0-0':'es'}}</span>
                                </td>
                            </tr>
                        }
                        @empty {
                            <tr>
                                <td colspan="4" class="text-center text-muted">
                                    No hay items para modificar
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
            <hr class="mt-5 mb-5">
            <div class="d-flex flex-row justify-center gap-20 mt-2">
                <button (click)="closeMdl();" class="btn btn-primary-outline text-center">Cancelar</button>
                <button 
                    class="btn btn-primary-outline text-center" 
                    (click)="saveChanges();"
                    [disabled]="items.length === 0">
                    Guardar cambios
                </button>
            </div>
        </div>
    </div>
</div>
